import { effects } from 'redux-saga'

import { requiresAuthentication } from 'internal-components/src/redux/modules/authentication'

export default function* loginOn403(getHref, action) {
  if (action.payload.type !== 'signup') {
    return
  }

  const state = yield effects.select()
  const authenticated = state.authentication.get('authenticated', false)

  if (authenticated) {
    // Permission problems, the request shouldnt have been sent through..
  }

  const returnTo = getHref(false)
  yield effects.put(requiresAuthentication(returnTo))
}



// WEBPACK FOOTER //
// ./src/redux/sagas/signup/loginOn403.js